import { dataURIToBlob } from "../helpers";
import axios from "axios";
import api from "@frontend/services/api/project";

export default {
  getTemplates (params = {}) {
    return axios.get('/video/templates/all', { params })
  },

  deleteTemplate (id) {
    return axios.delete(`/video/templates/${id}`)
  },

  attachTagToTemplate (id, tag) {
    return axios.post(`/video/templates/${id}/tag`, { tag })
  },

  detachTagFromTemplate (id, tagId) {
    return axios.delete(`/video/templates/${id}/tag/${tagId}`)
  },

  async updateThumbnails (id, thumbnails) {
    const req = new FormData();

    // Use a for...of loop to handle asynchronous processing correctly
    await (async () => {
      for (const { Image, Scene } of thumbnails) {
        const thumb = await api.base64ToFile(Image); // Wait for the promise to resolve
        req.append('thumbnails[]', thumb);
        req.append('scenes[]', Scene);
      }
      
      return axios.post(`/video/templates/${id}/thumbnails`, req);
    })();
  },
  getTemplatesByCustomer(id) {
    return axios.post(`/banner/get-templates/${id}`)
  },
  getTemplatesByIds(ids) {
    return axios.get(`/templates?ids=${ids}`);
  },
  createTemplate(customerId, layoutId, payload) {
    return axios.post(`/banner/${customerId}/group/${layoutId}/template`, payload);
  },
  createAdditionalFieldRow(id) {
    return axios.post(`/banner/templates/${id}/additional-fields`)
  },
  importTemplateToDebug(customer, layout, formData) {
    return axios.post(`/banner/${customer}/group/${layout}/import-for-debug`, formData)
  },
  updateLayout(customer_id, layout_id, data) {
    return axios.post(`/banner/${customer_id}/group/${layout_id}/update_ajax`, data);
  },
  updateLayoutTemplate(customer_id, layout_id, data) {
    return axios.put(`/banner/${customer_id}/group/${layout_id}/save_changes`, data);
  },
  getTemplateFields(customer_id, template_id) {
    return axios.get(`/banner/${customer_id}/group/0/get_feed_mapping_fields?template_id=${template_id}&is_web=0`)
  },
  copyToLayout(customer_id, layout_id, instance_id,  template_id, data) {
    return axios.post(`/banner/${customer_id}/group/${layout_id}/template/${instance_id}/${template_id}/copy-to-layout`, data);
  },
  createBackgroundColorField(template_id) {
    return axios.post(`/banner/templates/${template_id}/create-background-color-field`);
  },
  rename (id, name) {
    return axios.put(`/banner/templates/${id}/rename`, { name })
  },
}
